/** Türkiye cep numarası — E.164 (+90XXXXXXXXXX) */

const TR_MOBILE_LEN = 10;

export const normalizePhoneTR = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (!digits) return '';

  let local = digits;
  if (local.startsWith('90') && local.length === 12) local = local.slice(2);
  if (local.startsWith('0') && local.length === 11) local = local.slice(1);
  if (local.length !== TR_MOBILE_LEN || !local.startsWith('5')) return '';

  return `+90${local}`;
};

export const isPhoneLoginId = (value) => Boolean(normalizePhoneTR(value));

export const formatPhoneDisplay = (value) => {
  const e164 = normalizePhoneTR(value);
  if (!e164) return String(value ?? '').trim();
  const local = e164.slice(3);
  return `0${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6, 8)} ${local.slice(8)}`;
};
